/**
 * SEO utility — sets canonical URL and page title dynamically.
 * Call from useEffect in any public-facing page.
 */

const SITE_URL = 'https://www.ourbelong.com';

export function setCanonical(path) {
  const url = `${SITE_URL}${path}`;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = url;

  // Also update og:url
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.content = url;
  }
}

export function setPageMeta(title, description) {
  if (title) document.title = title;
  if (description) {
    let meta = document.querySelector('meta[name="description"]');
    if (meta) meta.content = description;
  }
}
